import { useModal } from "ui/atoms/Modal";

export const useLoadingBackdropOverlay = () => useModal(true);

export default useLoadingBackdropOverlay;
